module.exports = __webpack_public_path__ + "img/kzg.ed89a1c1.png";